<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar @on-selected="onDeviceSelect" :dateRangeMenu="false"></graph-tool-bar>
      <!-- <br /> -->
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <!-- <div class="card-icon">
            <md-icon>notifications_none</md-icon>
          </div>-->
          <h4 class="title">{{$lang.titles.paired_notifications}}</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="tableData" table-header-color="green">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="#">{{ item.ID }}</md-table-cell>
              <md-table-cell
                :md-label="$lang.inputs.notification_source"
              >{{ getNotifyType(item.notifyType) }}</md-table-cell>
              <md-table-cell
                :md-label="$lang.inputs.notification_destination"
              >{{ item.destination.name }}</md-table-cell>
              <md-table-cell md-label>
                <!-- <md-button
                  class="md-success md-just-icon md-simple"
                  @click="editNotification(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>-->
                <md-button
                  class="md-danger md-just-icon md-simple"
                  :title="$lang.keys.delete"
                  @click="deleteNotification(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-empty-state>
            <md-button class="md-info md-round" @click="openModal">
              <md-icon>add</md-icon>
              {{$lang.keys.add}}
            </md-button>
          </md-empty-state>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="showModal" @close="closeModal">
      <template slot="header">
        <h4 class="modal-title">{{$lang.titles.add_notification_pair}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-field :class="[{ 'md-error': errors.has('NOTIFY_TYPE') }]">
              <label>{{$lang.inputs.notification_source}}</label>
              <md-select
                v-model.number="modalData.notifyType"
                name="NOTIFY_TYPE"
                v-validate="modelValidation.required"
              >
                <md-option
                  v-for="(item, index) in notifyTypes"
                  :key="index"
                  :value="item.ID"
                  @click.native="selectNotifyType(item.ID)"
                >{{item.name}}</md-option>
              </md-select>

              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('NOTIFY_TYPE')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <md-field :class="[{ 'md-error': errors.has('NOTIFY_DESTINATION') }]">
              <label>{{$lang.inputs.notification_destination}}</label>
              <md-select
                v-model="modalData.notifyDestination"
                name="NOTIFY_DESTINATION"
                v-validate="modelValidation.required"
                :disabled="modalData.disableDestSelector"
              >
                <md-option
                  v-for="(item, index) in notifyDestOptions"
                  :key="index"
                  :value="item.ID"
                >{{item.name}}</md-option>
              </md-select>

              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('NOTIFY_DESTINATION')">close</md-icon>
              </slide-y-down-transition>
            </md-field>
          </div>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-success md-simple" @click="saveModal">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger md-simple" @click="closeModal">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import axios from "axios";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";
import { Modal } from "@/components";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";

export default {
  components: {
    graphToolBar,
    "snack-bar": snackBar,
    SlideYDownTransition,
    Modal
  },
  data() {
    return {
      modelValidation: {
        required: {
          required: true
        }
      },
      showModal: false,
      modalData: {
        notifyType: "",
        notifyDestination: "",
        disableDestSelector: true
      },
      availableNotifyTypes: [
        {
          ID: 1,
          name: "Device status"
        },
        {
          ID: 2,
          name: "NILM",
          deviceType: [1]
        },
        {
          ID: 3,
          name: "Anomaly",
          deviceType: [1]
        },
        {
          ID: 4,
          name: "Disconnector",
          deviceType: [2]
        }
      ],
      notifyTypes: [],
      notifyDestOptions: [],
      availableNotifyDestinations: [
        {
          ID: 1,
          ID_dest: 1,
          name: "Applied Precision Cloud"
        }
      ],
      tableData: [],
      loadedWebexSpaces: false
    };
  },

  created() {
    this.$store.commit("setLoading", true);
  },

  mounted() {},

  methods: {
    onDeviceSelect(data) {
      this.$store.commit("setLoading", true);
      this.selectedDevice = data.device;

      this.notifyTypes = [];
      this.availableNotifyTypes.forEach(notify => {
        if (notify.deviceType) {
          if (notify.deviceType.includes(data.device.type)){
            this.notifyTypes.push(notify);
          }
        } else {
          this.notifyTypes.push(notify);
        }
      });

      if (this.loadedWebexSpaces) {
        this.getNotificationPair(this.selectedDevice.mac).then(response2 => {
          this.$store.commit("setLoading", false);
        });
      } else {
        this.getWebexSpaces().then(response => {
          this.loadedWebexSpaces = true;
          this.getNotificationPair(this.selectedDevice.mac).then(response2 => {
            this.$store.commit("setLoading", false);
          });
        });
      }
    },

    openModal() {
      this.modalData = {
        notifyType: "",
        notifyDestination: "",
        disableDestSelector: true
      };

      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    saveModal() {
      this.$validator.validateAll().then(res => {
        if (res) {
          const notifyDestIndex = this.notifyDestOptions.findIndex(
            f => f.ID == this.modalData.notifyDestination
          );

          // //EDIT
          // if (this.modalData.edit_ID > 0) {
          //   const notifyIndex = this.tableData.findIndex(
          //     notifyArray => notifyArray.ID == this.modalData.edit_ID
          //   );
          //   this.tableData[notifyIndex].notifyType = this.modalData.notifyType;
          //   this.tableData[notifyIndex].destination = {
          //     ID: this.modalData.notifyDestination,
          //     ID_dest: this.notifyDestOptions[notifyDestIndex].ID_dest,
          //     name: this.notifyDestOptions[notifyDestIndex].name
          //   };

          // } else {}

          //NEW
          this.saveNotificationPair(
            this.modalData.notifyType,
            this.notifyDestOptions[notifyDestIndex].ID_dest,
            this.modalData.notifyDestination
          ).then(response => {
            if (response != -1) {
              this.tableData.push({
                ID: this.getMaxIDTableData() + 1,
                DB_ID: response,
                notifyType: this.modalData.notifyType,
                destination: {
                  ID: this.modalData.notifyDestination,
                  ID_dest: this.notifyDestOptions[notifyDestIndex].ID_dest,
                  name: this.notifyDestOptions[notifyDestIndex].name
                }
              });
            }
          });

          this.closeModal();
        }
      });
    },

    selectNotifyType(notify_ID) {
      this.notifyDestOptions = [...this.availableNotifyDestinations];

      this.tableData.forEach(row => {
        if (notify_ID === row.notifyType) {
          const findIndex = this.notifyDestOptions.findIndex(
            dest => dest.ID == row.destination.ID
          );
          this.notifyDestOptions.splice(findIndex, 1);
        }
      });

      if (this.notifyDestOptions.length !== 0) {
        this.modalData.disableDestSelector = false;
      }
    },

    getWebexSpaces() {
      return new Promise(async (resolve, reject) => {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/tools/notifications/webex-spaces",
          data: {
            user_token: getUserToken()
          }
        })
          .then(response => {
            response.data.data.forEach(space => {
              const name = "Webex (space: " + space.title + ")";
              this.availableNotifyDestinations.push({
                ID: space.ID,
                ID_dest: 2,
                name: name
              });
            });
            resolve(1);
          })
          .catch(error => {
            if (error.response.data.code !== 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
            resolve(-1);
          });
      });
    },

    getNotificationPair(deviceMAC) {
      return new Promise(async (resolve, reject) => {
        this.tableData = [];

        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/tools/notifications/pair",
          data: {
            user_token: getUserToken(),
            device_token: getSelectedDeviceToken(deviceMAC)
          }
        })
          .then(response => {
            response.data.data.forEach(notify => {
              let name = "";
              let destination_ID = 0;

              //Applied Precision Cloud
              if (notify.ID_notifyDestType == 1) {
                const destIndex = this.availableNotifyDestinations.findIndex(
                  d => d.ID_dest == notify.ID_notifyDestType
                );

                destination_ID = this.availableNotifyDestinations[destIndex].ID;
                name = this.availableNotifyDestinations[destIndex].name;

                //Webex space
              } else if (notify.ID_notifyDestType == 2) {
                const destIndex = this.availableNotifyDestinations.findIndex(
                  d => d.ID == notify.webex_space
                );

                destination_ID = this.availableNotifyDestinations[destIndex].ID;
                name = this.availableNotifyDestinations[destIndex].name;
              }

              this.tableData.push({
                ID: this.getMaxIDTableData() + 1,
                DB_ID: notify.ID,
                notifyType: notify.ID_notifyType,
                destination: {
                  ID: destination_ID,
                  ID_dest: notify.ID_notifyDestType,
                  name: name
                }
              });
            });
            resolve(1);
          })
          .catch(error => {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
            resolve(-1);
          });
      });
    },

    saveNotificationPair(notifyTypeID, notifyDestID, webex_space = null) {
      return new Promise(async (resolve, reject) => {
        let postData = {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          notifyTypeID: notifyTypeID,
          notifyDestID: notifyDestID
        };

        if (notifyDestID == 2) {
          postData.webex_space = webex_space;
        }

        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_W + "/tools/notifications/pair",
          data: postData
        })
          .then(response => {
            resolve(response.data.data.ID_notify);
          })
          .catch(error => {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );

            resolve(-1);
          });
      });
    },

    // editNotification(notify) {
    //   const notifyIndex = this.availableNotifyDestinations.findIndex(
    //     nd => nd.ID == notify.destination.ID);

    //   this.notifyDestOptions = [];
    //   this.notifyDestOptions.push(this.availableNotifyDestinations[notifyIndex]);

    //   this.modalData = {
    //     notifyType: notify.notifyType,
    //     notifyDestination: notify.destination.ID,
    //     disableDestSelector: false,
    //     edit_ID: notify.ID
    //   };

    //   this.showModal = true;
    // },

    deleteNotification(notify) {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_W + "/tools/notifications/pair",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          ID: notify.DB_ID
        }
      })
        .then(response => {
          const notifyIndex = this.tableData.findIndex(
            notifyArray => notifyArray.ID == notify.ID
          );
          this.tableData.splice(notifyIndex, 1);
        })
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    },

    getMaxIDTableData() {
      let maxID = Math.max.apply(
        Math,
        this.tableData.map(function(o) {
          return o.ID;
        })
      );

      if (maxID < 0) {
        maxID = 0;
      }
      return maxID;
    },

    getNotifyType(valueID) {
      const notifyIndex = this.notifyTypes.findIndex(n => n.ID == valueID);
      if (notifyIndex >= 0){
        return this.notifyTypes[notifyIndex].name;
      } else {
        return "";
      }
      
    }
  }
};
</script>

<style scoped>
.md-toolbar {
  position: inherit;
}
</style>
